import type {FAQType, FAQReferenceType} from '../types/block';
import {LocaleEnum} from '../types/locale';
import {stripHtmlTags} from './richTextUtils';

export function getStructuredData(data, pageKey = 'datoCmsPage') {
  const faqEntities = [];
  const pageContent = data[pageKey]?.content;
  const pageSchema = data[pageKey]?.structuredData;

  /*
   *  Loops through content sent to page
   *  determined by pageKey
   *  If there's any DatoCmsFaq blocks, it extracts
   *  information to form updated schema
   * */
  pageContent?.forEach(block => {
    if (block.__typename === 'DatoCmsFaq' || block.__typename === 'DatoCmsFaqsReference') {
      const title = block.__typename === 'DatoCmsFaq' ? (block as FAQType['block']).title : (block as FAQReferenceType['block']).faqsReference.title;

      const body = block.__typename === 'DatoCmsFaq' ? (block as FAQType['block']).body : (block as FAQReferenceType['block']).faqsReference.body;

      faqEntities.push({
        '@type': 'Question',
        name: stripHtmlTags(title || ''),
        acceptedAnswer: {
          '@type': 'Answer',
          text: stripHtmlTags(body || '')
        }
      });
    }
  });

  const faqSchema =
    faqEntities.length > 0
      ? JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: faqEntities
        })
      : null;

  const strippedPageSchema = pageSchema ? stripHtmlTags(pageSchema) : null;

  return {faqSchema, pageSchema: strippedPageSchema};
}

const GLOSSARY_PAGE_SLUG_PREFIX = {
  [LocaleEnum.AT]: 'lexikon',
  [LocaleEnum.DE]: 'lexikon',
  [LocaleEnum.CH]: 'lexikon',
  [LocaleEnum.IE]: 'glossary'
};

export const getGlossaryPageSlugPrefix = (locale: LocaleEnum) => {
  const prefix = GLOSSARY_PAGE_SLUG_PREFIX[locale];

  if (!prefix) {
    throw new Error(`Error building Glossary Item Page, there is no page for locale ${locale}`);
  }

  return prefix;
};
